import React from 'react';
import { Image } from 'react-native-web';
import { View } from 'react-native';
import { Android, promotion_cards } from '../../../../utils/DictionaryManagementUtils';
import {
  img_message_bar_android,
  img_scr_onboarding_03_a_and,
  promotion_carousel_page,
} from '../../../../utils/ImagesManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import ChoosePromotion from '../../AuxiliaryComponent/KeyboardPromotion/ChoosePromotion';

//= ========================================================================
const PromotionCardsFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const myStyles = {
    cleanImage: {
      marginTop: 85,
      width: 240,
      height: 33.3,
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={promotion_cards}
      cleanBackgroundImage={simPlatform === Android}
      WithImageBackground={simPlatform === Android ? img_scr_onboarding_03_a_and : promotion_carousel_page}
      hidePhoneHeadLine
      withOutPadding
      hideIcons
      withOutTopVerticalLine
      slideshowRefs={slideshowRefs}
      BackgroundColor="#fff"
    >
      {simPlatform === Android
            && (
            <View>
              <Image
                fadeDuration={0}
                style={myStyles.cleanImage}
                source={img_message_bar_android}
              />
              <ChoosePromotion globJSON={globJSON} />
            </View>
            )}
    </FullPageSimulator>

  );
};

export default PromotionCardsFP;
